<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">PIN Setting</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <b-button variant="primary" @click="showModalFormPINSetting('create', '')">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button>
        </b-col>
      </b-row>
      <br />
      <b-table
        responsive
        show-empty
        ref="pinSettingTable"
        :items="getDataPINSetting"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(username)="{ item }">
          <p class="mb-0">{{item.username}}</p>
        </template>
        <template v-slot:cell(pin)="{ item }">
          <p class="mb-0">Set</p>
        </template>
        <template v-slot:cell(user_type)="{ item }">
          <p class="mb-0">{{parsingUserTypes(item.user_type)}}</p>
        </template>
        <template v-slot:cell(failed_attempt)="{ item }">
          <p class="mb-0">{{item.failed_attempt}}</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row class="row">
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Edit" class="text-dark"
                @click="showModalFormPINSetting('edit', item.id)">
                <img src="@/assets/ic-edit.svg" class="mr-2" alt />
              </b-link>
            </div>
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Delete" class="text-dark"
                @click="deletePINSetting(item.id, item.username)">
                <img src="@/assets/rectangle.svg" class="mr-2" alt />
              </b-link>
            </div>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination align="right" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
            class="my-0"></b-pagination>
        </b-col>
      </b-row>
    </div>
    <b-modal v-model="modalFormPINSettingShow" size="sm" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <div class="container">
        <b-row>
          <b-col>
            <h4 class="font-weight-bold">{{ editModal ? 'Edit' : 'Create' }} PIN</h4>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              label="Username"
              label-for="username"
              style="font-size: 12px"
            >
              <b-form-select
                v-model="pin_setting.user_id"
                v-validate="'required'"
                name="username"
                data-vv-as="Username"
                id="username"
                class="form-control"
                v-on:change="updateUser($event)"
                :disabled="editModal"
              >
                <template v-slot:first>
                  <option value disabled>-- Pilih --</option>
                </template>
                <option v-for="claim_user in claim_users" :key="claim_user.Id" :value="claim_user.Id">{{claim_user.username}}</option>
              </b-form-select>
              <p style="width: 100%; font-size: 80%;color: #dc3545;">
                {{ veeErrors.first("username") }}
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              :label="editModal ? 'New PIN' : 'PIN'"
              label-for="pin"
              style="font-size: 12px"
            >
              <input
                v-model="pin_setting.pin"
                v-validate="'required|length:6'"
                name="pin"
                :data-vv-as="editModal ? 'New PIN' : 'PIN'"
                id="pin"
                class="form-control"
                :placeholder="editModal ? 'New PIN' : 'PIN'"
                ref="pin"
                maxlength="6"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
              />
            <b-form-invalid-feedback id="input-pin-feedback">{{
              veeErrors.first("pin")
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group
              id="fieldset-1"
              label-class="control-label"
              class="font-weight-bold required"
              :label="editModal ? 'New PIN Confirmation' : 'PIN Confirmation'"
              label-for="pin_confirmation"
              style="font-size: 12px"
            >
              <input
                v-model="pin_setting.pin_confirmation"
                v-validate="'required|confirmed:pin|length:6'"
                name="pin_confirmation"
                :data-vv-as="editModal ? 'New PIN Confirmation' : 'PIN Confirmation'"
                id="new_pin_confirmation"
                class="form-control"
                :placeholder="editModal ? 'New PIN Confirmation' : 'PIN Confirmation'"
                maxlength="6"
                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
              />
            <b-form-invalid-feedback id="input-pin_confirmation-feedback">{{
              veeErrors.first("pin_confirmation")?veeErrors.first("pin_confirmation").replace("confirmation", ''):''
            }}</b-form-invalid-feedback>
            </b-form-group>
          </b-col>
        </b-row>
        <br />
        <b-row>
          <b-col>
            <b-button variant="light" :disabled="loadingFormPINSetting"
              @click="modalFormPINSettingShow = !modalFormPINSettingShow" class="text-primary" block
              size="lg">Close</b-button>
          </b-col>
          <b-col>
            <b-button v-if="pin_setting.id != ''" variant="primary" :disabled="loadingFormPINSetting"
              @click="updatePINSetting()" block size="lg">
              <b-spinner v-if="loadingFormPINSetting"></b-spinner>
              <span v-else>Save</span>
            </b-button>
            <b-button v-else variant="primary" :disabled="loadingFormPINSetting" @click="createPINSetting()"
              block size="lg">
              <b-spinner v-if="loadingFormPINSetting"></b-spinner>
              <span v-else>Create</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <claim-pin-verification
      :showModal="modalFormPINVerificationShow"
      @close-pin-verification="closePINVerification"
      @after-submit-pin-verification="afterSubmitPINVerification">
    </claim-pin-verification>
  </div>
</template>

<script>
import claimPinVerification from "../../component/ClaimPINVerification.vue";

export default {
  components: { claimPinVerification },
  data() {
    return {
      filter: "",
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      fields: [
        {
          key: "username",
          label: "Username",
          sortable: false,
          class: "text-left"
        },
        {
          key: "user_type",
          label: "User Type",
          sortable: false,
          class: "text-left w-20"
        },
        {
          key: "pin",
          label: "PIN",
          sortable: false,
          class: "text-left w-10"
        },
        {
          key: "failed_attempt",
          label: "Failed Attempt",
          sortable: false,
          class: "text-left w-10"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      pin_setting: {
        id: "",
        user_id: "",
        username: "",
        pin: "",
        pin_confirmation: "",
        user_type: "",
      },
      user_types: [
        {text: "Claim Agent", value: "claim"},
        {text: "Claim Manager", value: "claim_manager"},
        {text: "Super Admin", value: "superadmin"}
      ],
      pin_settings : [],
      claim_users: [],
      editModal: false,
      modalFormPINSettingShow: false,
      loadingFormPINSetting: false,
      modalFormPINVerificationShow: false,
      pinVerificationFor: "createPIN",
      deletedPINSettingId: "",
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("ClaimSettingPINSettingModule/getClaimUsers")
      .then((response) => {
        this.claim_users = response.data.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    parsingUserTypes(userType) {
      const userTypeResult = this.user_types.find((el) => el.value == userType)
      if (userTypeResult) {
        return userTypeResult.text
      }

      return ""
    },
    getDataPINSetting(ctx, callback) {
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("ClaimSettingPINSettingModule/getAllPINSettingWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.pin_settings = response.data.data.results || [];
          callback(this.pin_settings);
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get pin settings",
            showConfirmButton: false,
            timer: 1500,
          });
          callback([]);
        });
      return null;
    },
    showModalFormPINSetting(action, id) {
      this.pin_setting = {
        id: "",
        user_id: "",
        username: "",
        pin: "",
        pin_confirmation: "",
        user_type: "",
      };

      if (action == 'edit') {
        this.$store
        .dispatch("ClaimSettingPINSettingModule/getPINSetting", id)
        .then(response => {
          let data = {...response.data.data}
          this.pin_setting.id = data.id;
          this.pin_setting.user_id = data.user_id;
          this.pin_setting.username = data.username;
          this.pin_setting.user_type = data.user_type;
        })
        .catch(error => {
          console.log(error);
        });

        this.editModal = true;
      } else {
        this.editModal = false;
      }

      this.modalFormPINSettingShow = !this.modalFormPINSettingShow;
    },
    closePINVerification() {
      this.loadingFormPINSetting = false;
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
    },
    afterSubmitPINVerification() {
      switch(this.pinVerificationFor) {
        case "createPIN":
          this.submitCreatePIN();
          break;
        case "updatePIN":
          this.submitUpdatePIN();
          break;
        case "deletePIN":
          this.submitDeletePIN();
          break;
      }
    },
    createPINSetting() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pinVerificationFor = "createPIN"
          this.loadingFormPINSetting = true;
          this.modalFormPINVerificationShow = true;
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    submitCreatePIN() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      const formData = new FormData();
      formData.append("user_id", this.pin_setting.user_id);
      formData.append("username", this.pin_setting.username);
      formData.append("pin", this.pin_setting.pin);
      formData.append("user_type", this.pin_setting.user_type);
      this.$store
        .dispatch("ClaimSettingPINSettingModule/createPINSetting", formData)
        .then((response) => {
          this.loadingFormPINSetting = false;
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
          this.modalFormPINSettingShow = false;
          this.$refs.pinSettingTable.refresh();
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response ? error.response.data.data : "Failed store PIN Setting",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
          this.loadingFormPINSetting = false;
        });
    },
    updatePINSetting() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.pinVerificationFor = "updatePIN"
          this.loadingFormPINSetting = true;
          this.modalFormPINVerificationShow = true;
        } else {
          this.$swal("ERROR!", "Your data can not be submitted.", "warning");
        }
      });
    },
    submitUpdatePIN() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      const formData = new FormData();
        formData.append("user_id", this.pin_setting.user_id);
        formData.append("username", this.pin_setting.username);
        formData.append("pin", this.pin_setting.pin);
        formData.append("user_type", this.pin_setting.user_type);
        this.$store
          .dispatch("ClaimSettingPINSettingModule/updatePINSetting", {
            id: this.pin_setting.id,
            formData
          })
          .then((response) => {
            this.loadingFormPINSetting = false;
            this.$swal({
              type: "success",
              title: "Your work has been saved",
              showConfirmButton: false,
              scrollbarPadding: false,
              timer: 1500,
            });
            this.modalFormPINSettingShow = false;
            this.$refs.pinSettingTable.refresh();
          })
          .catch((error) => {
            this.$swal({
              type: "error",
              title: "Oops...",
              text: error.response ? error.response.data.data : "Failed edit PIN Setting",
              showConfirmButton: false,
              scrollbarPadding: false,
              timer: 1500,
            });
            this.loadingFormPINSetting = false;
          });
    },
    deletePINSetting(id, username) {
      this.pinVerificationFor = "deletePIN"
      this.modalFormPINVerificationShow = true;
      this.deletedPINSettingId = id;
    },
    submitDeletePIN() {
      this.modalFormPINVerificationShow = !this.modalFormPINVerificationShow;
      this.$store.dispatch("ClaimSettingPINSettingModule/deletePINSetting", this.deletedPINSettingId)
        .then((response) => {
          this.$swal("Deleted!", "Your data has been deleted.", "success");
          this.$refs.pinSettingTable.refresh();
        })
        .catch((error) => {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response ? error.response.data.message : "Failed to delete",
            showConfirmButton: false,
            scrollbarPadding: false,
            timer: 1500,
          });
        });
        this.deletedPINSettingId = "";
    },
    updateUser(e) {
      if(e) {
        const claim_user = this.claim_users.find((el) => el.Id == e)
        if (claim_user) {
          this.pin_setting.username = claim_user.username
          this.pin_setting.user_type = claim_user.role 
        }
      }
    },
  }
};
</script>
